import * as React from 'react';
const TwentyFourOZIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    {...props}>
    <rect
      width={7}
      height={2}
      x={8.875}
      y={3.5}
      stroke="#fff"
      strokeLinejoin="round"
      rx={0.5}
    />
    <rect
      width={7}
      height={15}
      x={8.875}
      y={5.5}
      stroke="#fff"
      strokeLinejoin="round"
      rx={0.5}
    />
  </svg>
);
export default TwentyFourOZIcon;
